import FileOpenIcon from '@mui/icons-material/FileOpen';
import { Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import ReactComponent from '@/components/ReactComponent';
import fileDownload from 'js-file-download';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import Configuracao from '@/util/Configuracao';

class ExportarResumoPauta extends ReactComponent {
    cursor = 'pointer';
    cpfSignatario;
    anchorElExportarResumoPauta = null;
    openMenuExportarResumoPauta = Boolean(this.anchorElExportarResumoPauta);

    constructor(props) {
        super(props);

        makeObservable(this, {
            cursor: observable,
            cpfSignatario: observable,
            anchorElExportarResumoPauta: observable,
            openMenuExportarResumoPauta: observable,
            handleClickMenu: action,
            handleCloseMenu: action,
            exportarResumoDaPauta: action,
            temProcessosPJE: computed,
            temProcessosSIJ: computed
        });
    }

    handleClickMenu = (event) => {
        this.anchorElExportarResumoPauta = event.currentTarget;
        this.openMenuExportarResumoPauta = true;
    };

    handleCloseMenu = () => {
        this.anchorElExportarResumoPauta = null;
        this.openMenuExportarResumoPauta = false;
    };

    exportarResumoDaPauta = async (sistemaOrigem) => {
        this.carregarSignatario();
        let promise = this.pautaService.gerarResumoPauta(
            this.sessaoStore.idSessaoSelecionada,
            this.cpfSignatario,
            sistemaOrigem
        );
        promise.then((response) => {
            fileDownload(
                response,
                `resumo_pauta_${this.sessaoStore.idSessaoSelecionada}${sistemaOrigem ? `_apenas_${sistemaOrigem}` : ''}.txt`,
                'text/plain'
            );
        });
        this.handleCloseMenu();
    };

    carregarSignatario() {
        if (this.sessao?.orgaoJudicante) {
            this.cpfSignatario = this.dominioStore.temSignatariosCadastradosOjc(this.sessao.orgaoJudicante.sigla)
                ? this.dominioStore.signatarioCadastradoDefaultOjc(this.sessao.orgaoJudicante.sigla).cpf
                : this.usuarioStore.usuario.cpf;
        } else {
            this.cpfSignatario = this.usuarioStore.usuario.cpf;
        }
    }

    get sessao() {
        return this.sessaoStore.sessaoSelecionada;
    }

    get temProcessosPJE() {
        return this.sessaoStore.processosSessao.some(
            (processo) => processo.processo.origem === Configuracao.ORIGEM_PJE
        );
    }

    get temProcessosSIJ() {
        return this.sessaoStore.processosSessao.some(
            (processo) => processo.processo.origem === Configuracao.ORIGEM_SIJ
        );
    }

    render() {
        const menuId = 'exporta-resumo-pauta';

        return (
            <>
                <Tooltip title="Exportar resumo da pauta para arquivo texto (pauta-texto)">
                    <IconButton
                        data-testid="abrirMenuExportarResumoPauta"
                        id="iconeResumoPauta"
                        aria-label="exportar-resumo-pauta"
                        sx={{ ml: 0.5, mr: 0.5 }}
                        className="corBotaoAmarelo"
                        onClick={this.handleClickMenu}
                    >
                        <FileOpenIcon sx={{ color: 'white' }} />
                    </IconButton>
                </Tooltip>
                <Menu
                    id={menuId}
                    anchorEl={this.anchorElExportarResumoPauta}
                    open={this.openMenuExportarResumoPauta}
                    onClose={this.handleCloseMenu}
                    transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    sx={{ mt: 1 }}
                >
                    {this.temProcessosPJE && (
                        <MenuItem
                            onClick={() => this.exportarResumoDaPauta(Configuracao.ORIGEM_PJE)}
                            sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                        >
                            <Typography>Apenas PJe</Typography>
                        </MenuItem>
                    )}
                    {this.temProcessosSIJ && (
                        <MenuItem
                            onClick={() => this.exportarResumoDaPauta(Configuracao.ORIGEM_SIJ)}
                            sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                        >
                            <Typography>Apenas do eSIJ</Typography>
                        </MenuItem>
                    )}
                    {this.temProcessosPJE && this.temProcessosSIJ && (
                        <MenuItem
                            onClick={() => this.exportarResumoDaPauta()}
                            sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                        >
                            <Typography>Ambos (PJe e eSIJ)</Typography>
                        </MenuItem>
                    )}
                </Menu>
            </>
        );
    }
}

export default inject('stores')(observer(ExportarResumoPauta));
